import { Component, OnInit } from '@angular/core';
import {
  FlexiApiResourceService,
  SSRItemDTO
} from '@gtd/api-services/service-inventory';

@Component({
  selector: 'gtd-delay-insurance',
  templateUrl: './delay-insurance.component.html',
  styleUrls: ['./delay-insurance.component.scss']
})
export class DelayInsuranceComponent implements OnInit {
  constructor(private flexiApiResourceService: FlexiApiResourceService) {}

  ngOnInit() {}

  loadAvailablePlans() {
    // this.flexiApiResourceService.getBookingDetailUsingGET();
  }
}
